export default {
  fields: {
    country: 'Kraj banku',
    iban: 'IBAN',
    routing_number: 'Numer rozliczeniowy (routing)',
    account_number: 'Numer konta',
    sort_code: 'Sort code',
    account_type: 'Typ konta',
  },
  help: {
    country: 'Kraj banku, który może różnić się od kraju restauracji.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code i numer konta',
      description: 'Zwykły sposób wprowadzania brytyjskiego konta.',
    },
    iban: {
      title: 'IBAN',
      description: 'Międzynarodowy numer rachunku bankowego.',
    },
    us_local: {
      title: 'Numer rozliczeniowy i numer konta',
      description: 'Amerykańskie konto bankowe.',
    },
  },
  account_types: {
    checking: 'Rozliczeniowe',
    savings: 'Oszczędnościowe',
  },
  actions: {
    save: 'Zapisz konto bankowe',
    cancel: 'Anuluj',
    edit: 'Edytuj',
  },
  card: {
    account: 'Konto',
    country: 'Kraj',
    status: 'Status',
  },
  statuses: {
    active: 'Aktywne',
    pending_verification: 'W trakcie weryfikacji',
    action_needed: 'Wymagane działanie',
    errored: 'Wypłata nie powiodła się',
    missing: 'Brak',
  },
  notes: {
    pending_verification:
      'Adyen sprawdza każde konto bankowe przed rozpoczęciem wypłat. Potwierdź je na stronie Adyen, logując się do banku lub przesyłając wyciąg bankowy.',
    action_needed: 'Dostawca płatności nie mógł potwierdzić tego konta bankowego. Sprawdź dane lub podaj inne konto.',
    errored: 'Wypłata na to konto nie powiodła się, a wypłaty są wstrzymane. Sprawdź dane lub podaj inne konto.',
  },
};
